import { atom } from "jotai";

type TourIntroData = {
  header: string;
  description: string;
  totalSteps: number;
};

export const tourIntroStepAtom = atom<TourIntroData | null>(null);

tourIntroStepAtom.debugLabel = "tourIntroStepAtom";
